import { clsx } from 'clsx'

export const EditorSettingPageTitle = ({
  children,
  className,
}: {
  children?: React.ReactNode
  className?: string
}) => {
  return (
    <h2 className={clsx('font-medium text-2xl mb-8 leading-tight', className)}>
      {children}
    </h2>
  )
}
